module.exports = __webpack_public_path__ + "mercer.e0d82151d72165fd9d05ec75ac61780d.svg";